import { SettingsButton } from 'components/CantileverButton'
import { PageHeader } from 'components/PageHeader'
import { EXPLORER_HEADER_COLOR } from 'features/drilldown/colors'
import { PieChartIcon } from 'lucide-react'
import { FC } from 'react'
import styled from 'styled-components'

const APP_TITLE = 'Explorer'

const OuterHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-left: 25px;
  padding-right: 10px;
`

const InnerHeaderContainer = styled.div`
  width: 100%;
`

type DrilldownHeaderProps = {
  handleSettingsClick?: () => void
  explorationTitle?: string
}

const DrilldownHeader: FC<DrilldownHeaderProps> = ({
  handleSettingsClick,
  explorationTitle,
}) => {
  return (
    <OuterHeaderContainer style={{ backgroundColor: EXPLORER_HEADER_COLOR }}>
      <InnerHeaderContainer>
        <PageHeader
          title={APP_TITLE}
          subtitle={explorationTitle}
          icon={<PieChartIcon />}
          trailingContent={
            <SettingsButton title='Settings' onClick={handleSettingsClick} />
          }></PageHeader>
      </InnerHeaderContainer>
    </OuterHeaderContainer>
  )
}

export default DrilldownHeader
